export default "__VITE_ASSET__DmB8AU9C__"